import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';

import App from './app/app';

import '@fontsource-variable/inter/wght.css';
import '@fontsource/poppins/latin-600.css';
import '@fontsource/poppins/latin-700.css';
import '@fontsource/poppins/latin-800.css';
import './global/styles/global.css';

const container = document.getElementById('root');
const app = <StrictMode><App /></StrictMode>;

// Production HTML is prerendered (scripts/prerender.js); dev serves an empty root.
if (container.firstElementChild) hydrateRoot(container, app);
else createRoot(container).render(app);
